<template>
  <div>
    <div class="jumbotron p-4 p-md-5 text-white rounded bg-dark mb-3">
      <div class="col-md-12 px-0">
        <h1 class="display-4">乳山市</h1>
        <p class="lead mt-3 mb-0">
          乳山市因大乳山而得名，是中国沿海的长寿之乡，被授予“山东省长寿之乡”称号。乳山有省级重点文物保护单位3处，市县级重点文物保护单位13处。是中国著名作家冯德英长篇小说《苦菜花》《迎春花》《山菊花》故事背景发生地，也是闻名全国的民族先锋“马石山十勇士”英雄事迹发生地。
        </p>
      </div>
    </div>
    <div class="p-3 bg-white rounded">
      <div v-for="town of towns" :key="town.name" class="media mb-2">
        <div class="town-short-icon rounded bg-primary mr-3 text-center text-white d-flex align-items-center justify-content-center display-4">
          {{town.shortName}}
        </div>
        <div class="media-body">
          <h5 class="mt-0">
            <router-link :to="{name: 'TownDetail', params: {townId: town.name}}">{{town.name}}</router-link>
          </h5>
          {{town.introduction}}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import towns from '@/data/towns.json'
export default {
  data() {
    return {
      towns
    }
  }
}
</script>
<style scoped>
.media {
  padding-bottom: 1em;
}
.town-short-icon {
  width: 64px;
  height: 64px;
  font-size: 2.5em;
}
</style>